import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function routeMapSearchStateReducer(state = initialState.routeMapSearchState, action) {
    switch (action.type) {
        case types.UPDATE_MAP_SEARCHCRITERIA:
            return action.routeMapSearchState;
        case types.LOGOUT_SUCCESS:
            return initialState.routeMapSearchState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/routeMapSearchStateReducer.js